import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Tooltip } from '@components/common';
import SvgIcon from '@components/SvgIcon';

const FullItemIcon = styled(SvgIcon)`
  margin-top: 4px;
`;

const Wrapper = styled(Box)`
  border-right: 1px solid rgb(216, 216, 216);
  &:last-child {
    border-right: 0;
  }
`;

function CalendarViewHalfItem(props) {
  const {
    iconFill,
    serviceTypeIcon,
    timeframeIcon,
    timeframeTitle,
    fullTitle,
    iconProps,
    disabled,
    selected,
    onItemClick,
    extraItems,
    ...restProps
  } = props;

  let extraItemsToRender = extraItems;
  !!extraItems && extraItems.length > 1 ? extraItems.slice(1) : extraItems;

  if (extraItems && extraItems.length > 2) {
    extraItemsToRender = extraItems.slice(0, 1);
  }

  return (
    <Wrapper
      display="flex"
      flexDirection="column"
      alignItems={['center']}
      justifyContent={['center', 'flex-start']}
      position="relative"
      flex={1}
      onClick={() => {
        if (onItemClick) {
          onItemClick();
        }
      }}
    >
      {fullTitle ? (
        <Tooltip
          animation="scale"
          delay={[300, 0]}
          duration={300}
          content={fullTitle}
          theme="light-border"
          placement="bottom"
        >
          <span>
            <FullItemIcon
              name={serviceTypeIcon}
              disabled={disabled && !selected}
              fill={iconFill ? iconFill : undefined}
              {...iconProps}
            />
          </span>
        </Tooltip>
      ) : (
        <FullItemIcon
          name={serviceTypeIcon}
          disabled={disabled && !selected}
          fill={iconFill ? iconFill : undefined}
          {...iconProps}
        />
      )}

      {timeframeIcon && (
        <Tooltip
          animation="scale"
          delay={[300, 0]}
          duration={300}
          content={timeframeTitle}
          theme="light-border"
          placement="bottom"
        >
          <span>
            <FullItemIcon
              display={['none', 'block']}
              name={timeframeIcon}
              disabled={disabled && !selected}
              color={iconFill ? iconFill : 'gold'}
              {...iconProps}
            />
          </span>
        </Tooltip>
      )}

      {extraItemsToRender &&
        extraItemsToRender.map(addon => {
          const { name, icon: addonIcon, title } = addon;
          return (
            <Tooltip
              key={name}
              content={title}
              theme="light-border"
              arrow={true}
              duration={300}
              animation="scale"
              delay={[300, 0]}
            >
              <span>
                <FullItemIcon
                  name={addonIcon}
                  color={iconFill ? iconFill : 'gold'}
                  disabled={disabled}
                  {...iconProps}
                />
              </span>
            </Tooltip>
          );
        })}
    </Wrapper>
  );
}

CalendarViewHalfItem.propTypes = {
  iconFill: PropTypes.string,
  serviceTypeIcon: PropTypes.string.isRequired,
  timeframeIcon: PropTypes.string,
  timeframeTitle: PropTypes.string,
  fullTitle: PropTypes.string,
  iconProps: PropTypes.object,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onItemClick: PropTypes.func,
  extraItems: PropTypes.array,
  extraItemsPositionTop: PropTypes.object,
  extraItemsPositionLeft: PropTypes.object
};

export default CalendarViewHalfItem;
